var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemPhotoAttachment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18.4 5c.883 0 1.6.784 1.6 1.75v10.5c0 .966-.717 1.75-1.6 1.75H5.6c-.883 0-1.6-.784-1.6-1.75V6.75C4 5.784 4.717 5 5.6 5Zm-8 6.487-4.8 5.25v.513h12.8v-.513L16 14.112l-1.034 1.132a.752.752 0 0 1-1.132 0zm8-4.737H5.6v7.513L9.834 9.63a.752.752 0 0 1 1.132 0l3.434 3.757 1.034-1.132a.752.752 0 0 1 1.132 0l1.834 2.007zM16 8.5c.442 0 .8.391.8.875s-.358.875-.8.875-.8-.391-.8-.875.358-.875.8-.875"
})));
export default SvgGemPhotoAttachment;